import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { TextField, Button, Typography } from '@mui/material';
import GoogleSignInButton from './GoogleSignInButton';
import { requestLogin, loadUsers} from '../../redux/accountSlice';

const FormContainer = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',
}));

const Divider = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  color: theme.palette.text.secondary,
  '&::before, &::after': {
    content: '""',
    flex: 1,
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: theme.spacing(0, 1),
  },
}));

const SignInForm = ({ onForgotPassword }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();

  const handleEmailSignIn = async (e) => {
    e.preventDefault();
    try {
      await dispatch(requestLogin({ email, password }));
      // Load users after successful login
      await dispatch(loadUsers());
      // Login successful, navigation should be handled by the app router
    } catch (error) {
      // Error handling is done in the slice
      console.error('Login failed:', error);
    }
  };

  return (
    <>
      <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', mb: 2 }}>Entrar</Typography>
      <GoogleSignInButton />
      <Divider variant="body2" sx={{ my: 1 }}>ou</Divider>
      <FormContainer onSubmit={handleEmailSignIn}>
        <TextField
          fullWidth
          label="E-mail"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <TextField
          fullWidth
          label="Senha"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <Typography variant="body2" sx={{ textAlign: 'center', mt: -1 }}>
          <Link to="#" 
            onClick={(e) => {
              e.preventDefault(); 
              onForgotPassword(); 
            }} style={{ textDecoration: 'none' }}>
            <Typography component="span" color="primary">
              Esqueci minha senha
            </Typography>
          </Link>
        </Typography>

        <Button
          fullWidth
          variant="contained"
          type="submit"
          size="large"
          sx={{ mt: 2 }}
        >
          Entrar
        </Button>
      </FormContainer>
    </>
  );
};

export default SignInForm;